
import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import {
  errorMessage,
  assignEmployerTagsRoute,
  enterpriseApplicationsKey,
  employerApplicationsKey,
} from '@features/applications';
import axiosInstance from '@server/axiosInstance';
import { applicantDetailsKey } from '@features/applicant';

type useEmployerAssignTagsProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
};

export const useEmployerAssignTags = ({
  setErrorText = () => { },
}: useEmployerAssignTagsProps) => {
  const client = useQueryClient();

  const { mutate: assignTags, isLoading: isAssignTagsLoading } =
    useMutation({
      mutationFn: (variables: {
        application_id: number[];
        tags: number[];
      }) => {
        return axiosInstance
          .post(assignEmployerTagsRoute, variables, {
            headers: {
              'Content-Type': 'application/json',
            },
          })
          .then((res) => res.data);
      },
      onSuccess: (data) => {
        if (data.status !== 200) {
          setErrorText(data.message);
        } else {
          setErrorText('');
          client.invalidateQueries(enterpriseApplicationsKey);
          client.invalidateQueries(applicantDetailsKey);
          client.invalidateQueries(employerApplicationsKey);
        }
      },
      onError: () => {
        setErrorText(errorMessage);
      },
    });

  return {
    assignTags,
    isAssignTagsLoading,
  };
};
